import React, { useState, useEffect } from "react"
import { GlobalStyles, Primary } from "./Layout.styles"
import Header from "../Header/Header"
import Hamburger from "../Hamburger/Hamburger"
import OverlayMenu from "../OverlayMenu/OverlayMenu"
import Footer from "../Footer/Footer"
import PropTypes from "prop-types"
import { Script } from "gatsby"
// import { SkipToMain } from "../SkipToMain/SkipToMain"
import EmployeeNavigation from "../EmployeeNavigation/EmployeeNavigation"
import { useMenuQuery } from "../../hooks/useMenuQuery"
import styled from "styled-components"

const Layout = ({ children, employeePage = false }) => {
  const [displayMenu, setDisplayMenu] = useState(false)
  const [userInfo, setUserInfo] = useState(null)
  const [userLoaded, setUserLoaded] = useState(false)

  const handleOverlayMenu = () => setDisplayMenu(prev => !prev)
  // Nav menu items
  const navMenuData = useMenuQuery()

  const Wrapper = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    margin-top: ${userInfo?.userDetails ? "50px" : "0"};
  `

  useEffect(() => {
    if (userLoaded) return

    async function getUserInfo() {
      try {
        const response = await fetch("/.auth/me")
        const payload = await response.json()
        const { clientPrincipal } = payload
        setUserLoaded(true)

        setUserInfo(clientPrincipal)
      } catch (error) {
        console.error(error)
        setUserLoaded(true)
      }
    }
    getUserInfo()
  }, [userLoaded, setUserLoaded, userInfo, setUserInfo])

  return (
    <>
      {userInfo?.userDetails && (
        <EmployeeNavigation employeePage={employeePage} userInfo={userInfo} />
      )}
      <GlobalStyles />
      {/* <SkipToMain /> */}
      <Wrapper>
        <Header navMenuData={navMenuData} employeePage={employeePage} />
        <Hamburger
          handleOverlayMenu={handleOverlayMenu}
          displayMenu={displayMenu}
        />
        <OverlayMenu
          displayMenu={displayMenu}
          callback={handleOverlayMenu}
          navMenuData={navMenuData}
          employeePage={employeePage}
        ></OverlayMenu>
        {/* <Main /> */}

        <Primary>{children}</Primary>

        <Footer />
      </Wrapper>

      <Script
        id="ultimate_blocks-content-toggle-front-script-js"
        src="/Scripts/ub-wp.js"
      />
      <Script src="https://docs.fs.illinois.edu/wp-content/plugins/ultimate-blocks/src/blocks/tabbed-content/front.build.js?ver=3.2.1" />
      <Script src="https://docs.fs.illinois.edu/wp-content/plugins/ultimate-blocks/src/blocks/scrollby-polyfill.js?ver=3.2.1" />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.any.isRequired,
}

export default Layout
